import React from "react"
import { Link } from "react-router-dom";
import CrossIcon from '../../assets/images/lystfacelogos/CrossIcon.svg'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


const RightSideModal = ({ popupDetails, children, primaryButtonDisabled = false }) => {
    const { open, title, titleText, bodyText, toggle = false, primaryButtonText, secondaryButtonText, primaryButtonPath, secondaryButtonPath, handleClickPrimaryButton, handleClickSecondaryButton, handleClose, subText, inputRef } = popupDetails

    return (
        <div className="modal-right">
            <Modal isOpen={open} className={`popup-container right-side-modal`}
                toggle={toggle ? handleClose : null}
            >
                <div className="modal-header">
                    <div className="title">{titleText}</div>
                    {handleClose && <div className="close-icon" onClick={handleClose}><img src={CrossIcon} /></div>}
                </div>
                <ModalBody className="modal-body">
                    {children && children}
                </ModalBody>
                <ModalFooter className="modal-footer">
                    {secondaryButtonText &&
                        <Button className="popup-button-secondary" onClick={handleClickSecondaryButton} >
                            {secondaryButtonText}
                        </Button>}
                    {primaryButtonText && <Button disabled={primaryButtonDisabled} className="popup-button-primary" onClick={() => handleClickPrimaryButton(title)}>
                        {primaryButtonText}
                    </Button>}
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default RightSideModal
